import { Skeleton } from "@mui/material";
import { ComponentType, createElement, CSSProperties } from "react";
import { useSnapshot } from "valtio";
import { useTreeViewItem } from "../../../controllers/TreeViewController/hooks/treeViewItemHooks";
import type { TreeViewListItem } from "../../../controllers/TreeViewController/types/ListItem";

type FoldersListItemProps = {
	item: TreeViewListItem;
	style: CSSProperties;
	ListItemComponent: ComponentType<{ item: TreeViewListItem }>;
};

const FoldersListItem: React.FC<FoldersListItemProps> = ({ item, style, ListItemComponent }) => {
	const { isLoading } = useSnapshot(item);
	useTreeViewItem(item);

	return (
		<div className="w-full h-[40px] mb-2" style={style}>
			{isLoading ? (
				<Skeleton width={"100%"} height={"100%"} className="box-border scale-100 rounded-lg" />
			) : (
				<div className="relative w-full h-full flex items-center">
					{createElement(ListItemComponent, {
						item,
					})}
					{/* <FolderOrDocumentListItem item={item} /> */}
				</div>
			)}
		</div>
	);
};
export default FoldersListItem;
